import script from "./PermissionsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsTable.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionsTable.vue?vue&type=style&index=0&id=43b3b712&lang=scss"

const __exports__ = script;

export default __exports__